import { triggerSimpleAjax } from "../../helpers/httpHelper";
import { SKU_LITE_API } from "../../helpers/constants/apiUrl";

export default function getSkuLite(search = "", page = 1, pageSize = 10) {
    return new Promise((res, rej) => {
        let queryParams = [];
        if (search) {
            queryParams.push(`search=${encodeURIComponent(search)}`);
        }
        if (page) {
            queryParams.push(`page=${page}`);
        }
        if (pageSize) {
            queryParams.push(`page_size=${pageSize}`);
        }

        const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
        const url = `${SKU_LITE_API}${queryString}`;

        triggerSimpleAjax(
            url,
            "GET",
            {},
            (response) => {
                res(response);
            },
            (error) => {
                rej(error);
            }
        );
    });
}
